import firestoreServices from './firestore.service';

const clientsFirestoreServices = firestoreServices('clients');

export default {
  ...clientsFirestoreServices
};
